module.exports = __webpack_public_path__ + "static/img/6.c1a7ba7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/zh/6.png
// module id = QgB8
// module chunks = 0